import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { toaster } from '@enechain/ecloud-designsystem'

import { saveBillingEmails } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BffAdminService } from '~/gen/proto/bff/v1/admin_pb'

/**
 * 全体送付先 + プロダクト個別送付先をまとめて保存するミューテーション。
 * 保存後は一覧 (listBillingEmails) のキャッシュを無効化する。
 */
export function useBillingEmailsMutation(
  organizationId: string,
): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()
  return useMutation(saveBillingEmails, {
    onError: (error) => {
      toaster.create({
        title: error.message,
        type: 'error',
      })
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.listBillingEmails,
          input: { organizationId },
          cardinality: 'finite',
        }),
      })
    },
  })
}
